const dashboard = 'dashboard';
const login = 'login';
const error = 'error';
const register = 'register';
const userDetails = 'user_details';
const vendorDetails = 'vendors';
const organization = 'organization';
const roles = 'roles';
const permissions = 'permissions';
const incentiveProgram = 'incentive_program';
const attribute = 'user_attr_master_mapping';
const profile = 'profile';
const bulkUser = 'get_user_bulk_upload_data';
const certificate = 'certificate';
const orgAccessControl = 'org_access_control';

const resourceName = {
  dashboard,
  login,
  error,
  register,
  userDetails,
  organization,
  roles,
  incentiveProgram,
  attribute,
  permissions,
  profile,
  bulkUser,
  vendorDetails,
  certificate,
  orgAccessControl,
};

export default resourceName;
